























import Vue from 'vue';
import Embed from 'v-video-embed';

// global register
Vue.use(Embed);

export default Vue.extend({
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    embedClass: {
      type: String,
      required: false,
      default: 'embed-responsive-16by9',
    },
    videoTitle: {
      type: String,
      required: false,
      default: '',
    },
    showCloseBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});

